import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Cell = styled.div`
  height: 70px;
  width: 195px;
  border-radius: 35px;
  background: #fa6801;
  padding: 10px 32px;
  margin: 0 auto;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  vertical-align: middle;
`;

const Text = styled.span`
  color: white;
  font-size: 36px;
  line-height: 50px;
  vertical-align: middle;
  margin-left: 8px;
  white-space: nowrap;
`;

class StatusFlag extends Component {
  render() {
    return (
      <Cell style={{ backgroundColor: this.props.color }}>
        <Icon src={this.props.icon} />
        <Text>{this.props.text}</Text>
      </Cell>
    );
  }
}

StatusFlag.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
};

StatusFlag.defaultProps = {
  color: '',
};

export default StatusFlag;



// WEBPACK FOOTER //
// ./src/components/status-flag.jsx